import { render, staticRenderFns } from "./AddressTemplate.vue?vue&type=template&id=37255a8b&scoped=true&"
import script from "./AddressTemplate.vue?vue&type=script&lang=js&"
export * from "./AddressTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37255a8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37255a8b')) {
      api.createRecord('37255a8b', component.options)
    } else {
      api.reload('37255a8b', component.options)
    }
    module.hot.accept("./AddressTemplate.vue?vue&type=template&id=37255a8b&scoped=true&", function () {
      api.rerender('37255a8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/AddressTemplate.vue"
export default component.exports